import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import './BackToTop.css'; // Assurez-vous d'importer le fichier CSS pour le style

const BackToTop = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  // Détecter le scroll pour afficher/masquer le bouton
  useEffect(() => {
    const toggleVisibility = () => {
      // Afficher le bouton quand on descend à plus de 300px
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Fonction pour remonter en haut de la page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Animation de défilement fluide
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="back-to-top-button"
          aria-label={t('backToTop.ariaLabel')}
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            strokeWidth={2.5} 
            stroke="currentColor" 
            className="back-to-top-icon"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="m4.5 15.75 7.5-7.5 7.5 7.5" 
            />
          </svg>
        </button>
      )}
    </>
  );
};

export default BackToTop;